import { render, staticRenderFns } from "./UiCopyButton.vue?vue&type=template&id=392bbc1f&"
import script from "./UiCopyButton.vue?vue&type=script&lang=js&"
export * from "./UiCopyButton.vue?vue&type=script&lang=js&"
import style0 from "./UiCopyButton.vue?vue&type=style&index=0&id=392bbc1f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports